export default __webpack_public_path__ + "static/media/checked.ade74677.svg";